import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class FractalChaosBandsTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      origin: originProp,
      appearance,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const { currentItem } = moreProps;

    if (!isDefined(currentItem)) return null;

    const data = yAccessor(currentItem);
    if (!isDefined(data)) return null;

    const { fractalHigh, fractalLow } = data;

    const highFormatted = isDefined(fractalHigh)
      ? displayFormat(fractalHigh)
      : "n/a";
    const lowFormatted = isDefined(fractalLow)
      ? displayFormat(fractalLow)
      : "n/a";

    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const strokeHighColor = appearance?.strokeHigh?.color || "#4CAF50";
    const strokeLowColor = appearance?.strokeLow?.color || "#F44336";

    return (
      <g
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-fractal-chaos-bands"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill="#FFFFFF">
            {"Fractal Chaos Bands: "}
          </ToolTipTSpanLabel>
          <tspan fill={strokeHighColor}>{`H: ${highFormatted}`}</tspan>
          <ToolTipTSpanLabel fill="#FFFFFF">{", "}</ToolTipTSpanLabel>
          <tspan fill={strokeLowColor}>{`L: ${lowFormatted}`}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

FractalChaosBandsTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    strokeHigh: PropTypes.shape({ color: PropTypes.string }),
    strokeLow: PropTypes.shape({ color: PropTypes.string }),
  }),
};

FractalChaosBandsTooltip.defaultProps = {
  displayFormat: format(".2f"),
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default FractalChaosBandsTooltip;
